import { getVerStatusKeyPerson } from "../action/getVerStatusKeyPerson";
import { BusinessDetailsData } from "../types/VerBusinessDetailsType";
import { createSlice } from "@reduxjs/toolkit";

const initialState: BusinessDetailsData = {
  data: null,
  loading: false,
  error: null,
  successfull: false,
};

const verStatusKeyPersonSlice = createSlice({
  name: "verStatusKeyPersonSlice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getVerStatusKeyPerson.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getVerStatusKeyPerson.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        // // console.log("DATA createAppSlice", action);
      })
      .addCase(getVerStatusKeyPerson.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const verStatusKeyPersonReducer = verStatusKeyPersonSlice.reducer;
